import { useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { PanelLeft } from "lucide-react";
import ResponsiveSidebarContainer from "../../components/Modal/ModalImageEdit/shared/ResponsiveSidebarContainer";
import VideoEditorPropertiesPanel from "./VideoEditorPropertiesPanel";
import { useTranslationApp } from "../../lib/i18next";
import { MODAL_VIDEO_EDITOR_PROPERTIES_TITLE } from "../../i18n/keysTranslations";

const VIDEO_EDITOR_PROPERTIES_PANEL_SX = {
  width: { xs: "100%", md: 320 },
  maxWidth: { xs: "100%", md: 320 },
  height: { xs: "100%", md: "100%" },
  flexShrink: 0,
  bgcolor: "background.paper",
  borderLeft: { xs: 0, md: "1px solid rgba(0, 0, 0, 0.12)" },
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  position: "relative",
};

const VideoEditorPropertiesDrawer = ({
  open = false,
  onOpenChange = () => {},
}) => {
  const { t } = useTranslationApp();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const title = t(MODAL_VIDEO_EDITOR_PROPERTIES_TITLE);
  const panel = (
    <VideoEditorPropertiesPanel
      headerAction={
        <IconButton
          aria-label={title}
          onClick={() => onOpenChange(false)}
          size="small"
          edge="start"
          sx={{ pl: 0.2 }}
        >
          <PanelLeft size={18} color="currentColor" />
        </IconButton>
      }
    />
  );

  useEffect(() => {
    onOpenChange(!isSmallScreen);
  }, [isSmallScreen, onOpenChange]);

  if (isSmallScreen) {
    return (
      <ResponsiveSidebarContainer
        isSmallScreen
        open={open}
        onClose={() => onOpenChange(false)}
        paperWidth={320}
        anchor="right"
      >
        <Box sx={VIDEO_EDITOR_PROPERTIES_PANEL_SX}>{panel}</Box>
      </ResponsiveSidebarContainer>
    );
  }

  if (!open) {
    return null;
  }

  return <Box sx={VIDEO_EDITOR_PROPERTIES_PANEL_SX}>{panel}</Box>;
};

export default VideoEditorPropertiesDrawer;
